module.exports = __webpack_public_path__ + "img/swiper_3.0_5_1.680b1e24.webp";